import { extractApiData } from '@/shared/lib/apiErrorHandler';
import apiClient, { API_BASE_LOGIN_URL } from '@/shared/api/client';
import { ApiResponse } from '@/shared/api/types';
import { MemberResponse } from '../model/types';
import { MeetupHistoryResponse } from '@/entities/meetup';

/**
 * 카카오 로그인 시작
 */
export const initiateKakaoLogin = () => {
  window.location.href = `${API_BASE_LOGIN_URL}/oauth2/authorization/kakao`;
};

/**
 * 사용자 정보 가져오기
 * @returns 사용자 정보
 */
export const getMemberInfo = async (): Promise<MemberResponse> => {
  return extractApiData(() => apiClient.get<ApiResponse<MemberResponse>>('/v1/members/me'), '사용자 정보 가져오기');
};

/**
 * 사용자 정보 업데이트
 * @param member 사용자 정보
 * @returns
 */
export const updateMemberInfo = async (member: Partial<MemberResponse>): Promise<MemberResponse> => {
  return extractApiData(
    () => apiClient.post<ApiResponse<MemberResponse>>('/v1/members/complete-registration', member),
    '사용자 정보 업데이트',
  );
};

/**
 * 멤버의 이전 밋업 참여 내역 가져오기
 * @param memberId 멤버 ID
 * @returns 이전 밋업 참여 내역 목록
 */
export const getMemberMeetupHistory = async (memberId: number): Promise<MeetupHistoryResponse> => {
  return extractApiData(
    () => apiClient.get<ApiResponse<MeetupHistoryResponse>>(`/v1/admin/members/${memberId}/meetup-history`),
    '멤버 밋업 참여 내역 가져오기',
  );
};
